/**
 * Synchronous global mirror of the authenticated state.
 * Why: TanStack Router's `beforeLoad` runs synchronously and reads from the router
 * context, but React context updates are batched/async — meaning after a login() the
 * router still sees the *previous* context. So we duplicate the minimal auth state
 * here and update it imperatively from the AuthProvider's effects.
 *
 * Usage: only call `isAuthenticatedSync()` from route guards. Components should keep
 * using `useAuth()` for reactive reads.
 */

interface AuthMirror {
  token: string | null;
  tenantId: string | null;
}

let mirror: AuthMirror = { token: null, tenantId: null };

export function setAuthMirror(next: AuthMirror): void {
  mirror = next;
}

export function isAuthenticatedSync(): boolean {
  return Boolean(mirror.token);
}

export function getAuthMirror(): AuthMirror {
  return mirror;
}
